<!--
     <ProcessDependingUserField
       :props="my_attrs_dictionary"
       @bind="my_bind_handler"
     />

     Public propertys:
       value → Gives the field's serializable value

     Accepted props:
     - id [REQUIRED] → This instance id.
     - process_field_id [REQUIRED] → The id of a process select to watch
     - permission_id [REQUIRED] → The permission_id, like "NCDEFAULT.evaluador"
     - multiple (default: false)
     - value
     - label
     - placeholder
-->

<template>
  <v-select
    v-model="props.value"
    :items="items"
    :label="props.label"
    :placeholder="props.placeholder"
    :multiple="props.multiple"
    :loading="loading"
    item-value="0"
    item-text="1"
    :rules="rules"
    :class="[props.class || 'qmkey-form-input', {'required':props.required}]"
    outlined
    dense
  >
  </v-select>
</template>


<script>
import { mapState } from 'vuex'
import QUnitWidgets from '@/api/QUnitWidgets'

export default {
  name: 'Select',

  props: ['props'],

  data: () => ({
    items: [],
    loading: false,
    process_id: '',
  }),

  computed: {
    ...mapState(['sitePath']),

    value() {
      return this.props.value
    },
    
    rules() {
      // TODO: Multilang: Change hardcoded string
      return [(value) => !!value || !this.props.required || 'Campo requerido']
    },
  },

  mounted() {
    this.$emit(
      'bind',
      this.props.id,
      this.props.process_field_id,
      this.update_items,
    )
    this.items = this.props.items || []
  },

  methods: {
    validate() {
      // TODO: Show error message
      return !this.props.required || !!this.value
    },

    update_items(process_id) {
      if (!process_id) {
        this.props.value = null
        return
      }

      this.loading = true
      // Updates the information because another process is selected
      console.log('ProcessDependingUserField.update_items(', process_id, ')')
      QUnitWidgets.get_process_depending_users(this.sitePath, {
        process_id: process_id,
        permission_id: this.props.permission_id,
      })
        .then(
          function (data) {
            this.loading = false
            console.log(
              'DEBUGGING ProcessDependingUserField.update_items() → ',
              data,
            )
            this.items = data.data
          }.bind(this),
        )
        .catch((err) => console.warn(err)) // DEBUG
    },

    error_state(ok) {
      this.valid = ok
    },
  },
}
</script>
<style lang="scss">
@import '@/sass/modalform.scss';
</style>